export const FORM_ID = 'client-settings--unlink-and-delete-modal-form';

export const MODAL_HEADER_ID = 'client-settings--unlink-and-delete-modal-header';

export interface FormValues {
  deleteAccountsFromHousehold: boolean;
}

export const TOAST_SUCCESS_MESSAGE = 'Orion Connect Household ID unlinked successfully.';

export const TOAST_ERROR_MESSAGE =
  'Something went wrong and we were unable to unlink the household ID.';
